import { Params } from '@angular/router';
import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';

export interface RouterStateUrl {
  url: string;
  queryParams: Params; // i.e. /route?param1=value1&param2=value2
  params: Params; // i.e. /route/1
}

export interface State {
  router: RouterReducerState<RouterStateUrl>;
}

export const reducers: ActionReducerMap<State> = {
  router: routerReducer,
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Feature selector: router.
 */
export const getRouterState = createFeatureSelector<RouterReducerState<RouterStateUrl>>('router');

export const getCurrentModule = createSelector(getRouterState, (state: RouterReducerState<RouterStateUrl>) =>
  state.state.url ? state.state.url.split('/')[1] : ''
);

export * from './travel-booking/';
export * from './travel-search/';
export * from './travel-information';
export * from './filter';
export * from './customizable-assets';
